@let tools = store.toolbarToolsSg();

<div class="atn-ds-table-toolbar">
  @for (tool of tools; track tool.id) {
    <button
      class="atn-ds-table-toolbar__tool"
      [class.atn-ds-table-toolbar__tool--disabled]="tool.disabled"
      [class.atn-ds-table-toolbar__tool--loading]="tool.loading"
      [attr.aria-label]="tool.label ?? tool.title ?? tool.id"
      [attr.aria-disabled]="tool.disabled || tool.loading"
      [attr.title]="tool.title"
      [disabled]="tool.disabled || tool.loading"
      type="button"
      (click)="toolClickHandler($event, tool)"
    >
      @if (tool.iconClass) {
        <i [class]="tool.iconClass"></i>
      }
      @if (tool.label) {
        <span>{{ tool.label }}</span>
      }
    </button>
  }

  <ng-content />

  @if (store.showColumnSettingsSg()) {
    <atn-ds-table-settings />
  }
</div>
